import Calendar from "./components/calendar/Calendar";
import Header from "./components/Header";
import BanerPhoto from "./components/BanerPhoto";
import OfferSection from "./components/OfferSection";
import Footer from "./components/Footer";
import { useState } from "react";
import DiscountExchange from "./components/pointsExchange/DiscountExchange";
import MoneyExchange from "./components/pointsExchange/MoneyExchange";
import { imagesData1, imagesData2 } from "./utils/infoSection";
import { ContactTeaser } from "./components/ContactTeaser";
function HomePage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [inProgress, setInProgress] = useState(false)
  const [points,setPoints] = useState();
  return (
    <div>
      <BanerPhoto></BanerPhoto>
      <OfferSection tittle={'info-section'} imagesData={imagesData2}></OfferSection>
      <OfferSection tittle={'offer-section'} imagesData={imagesData1}></OfferSection>

    <Calendar setInProgress={setInProgress} setIsLoggedIn={setIsLoggedIn}></Calendar>
    <ContactTeaser></ContactTeaser>
    {isLoggedIn ? 
    <>
    <MoneyExchange 
      isLoggedIn={isLoggedIn} 
      points={points}
      setPoints={setPoints}>
    </MoneyExchange>
    <DiscountExchange 
      setPoints={setPoints} 
      poinst={points} 
      isLoggedIn={isLoggedIn}>
    </DiscountExchange> </>     : <></> 
      }
    </div>
  );
}

export default HomePage;